import { useEffect, useState } from 'react'
import type { HDStethEcgSnapshot, HDStethEcgSource } from '@/utils/hdSteth/ecg-types'

/**
 * Subscribe to a derived value of the ECG store (React 17 has no useSyncExternalStore).
 * Pass a module-level `select` returning a primitive: the component re-renders only when that value changes.
 */
export function useHDStethEcgValue<T>(source: HDStethEcgSource | undefined, select: (snapshot: HDStethEcgSnapshot | undefined) => T): T {
  const [value, setValue] = useState<T>(() => select(source?.getSnapshot()))

  useEffect(() => {
    const update = (): void => setValue(() => select(source?.getSnapshot()))
    update()
    return source?.subscribe(update)
  }, [select, source])

  return value
}
